import { SxProps, Theme } from '@mui/material';

const actionButtonSx = (box: string, icon: string, radius: string): SxProps<Theme> => ({
  width: box,
  height: box,
  padding: 0,
  borderRadius: radius,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: (theme) => theme.palette.custom.OV.sys.onSurfaceVariant,
  '& .MuiSvgIcon-root, & svg': { width: icon, height: icon, fontSize: icon },
  // a symbol glyph carries the font's own line box, which is taller than the glyph
  // and would push it off-centre inside a button this small
  '& .material-symbols-rounded, & .material-symbols-outlined': {
    fontSize: icon,
    width: icon,
    height: icon,
    lineHeight: 1,
  },
  '&:hover': {
    backgroundColor: (theme) => theme.palette.custom.OV.sys.surfaceContainerHigh,
    color: (theme) => theme.palette.custom.OV.sys.onBackground,
  },
});

/**
 * The copy / share / options controls a side-panel card carries in its header.
 * They are quiet by default and only draw a surface under the pointer, so a card
 * reads as content first and a toolbar second.
 */
export const sidePanelActionButtonSx = actionButtonSx('1.625rem', '0.9375rem', '0.4375rem');

/**
 * The same control sitting on a caption line rather than in a card header. It is
 * smaller so the line keeps the caption's own height instead of a button's.
 */
export const sidePanelCaptionActionButtonSx = actionButtonSx(
  '1.125rem',
  '0.875rem',
  '0.375rem',
);
